const validaMobileInitialState = {
    validaMobile: {
      loading: false,
      error: null,
      data: null,
    },
  };
  
  export default validaMobileInitialState;
  